import { Component, OnInit } from '@angular/core';
import { loadingFade, modal, alert } from '../../animacoes';
import { FormBuilder, FormGroup } from '@angular/forms';

import { AuthService } from '../services/auth.service';
import { ClienteService } from '../services/cliente.service';
import Swal from 'sweetalert2';

@Component({
	selector: 'app-agencias',
	templateUrl: './agencias.component.html',
	styleUrls: ['./agencias.component.css'],
	animations: [loadingFade, modal, alert]
})
export class AgenciasComponent implements OnInit {
	public loading = false;
	public clientes = [];

	// paginacao
	public page = 1;
	public limit = 10;
	public count = 0;

	constructor(private fb: FormBuilder,
		private clienteSvc: ClienteService,
		private authSvc: AuthService) { }


	ngOnInit() {
		this.loading = true;
		this.pegaClientes();
	}

	pegaClientes() {
		this.clienteSvc.getClientes().then((data: any) => {
			this.clientes = data;
			this.count = this.clientes.length;
			this.loading = false;
		}).catch((err) => {
			this.loading = false;
			console.log(err);
		});
	}

	primPagina() {
		this.page = 1;
	}

	paginaAnt() {
		this.page = Math.max(this.page - 1, 1);
	}

	proxPagina() {
		this.page = Math.min(this.page + 1, Math.ceil(this.count / this.limit));
	}

	ultPagina() {
		this.page = Math.ceil(this.count / this.limit);
	}

	apagaCliente(id) {
		Swal.fire({
			type:'warning',
			title: 'Deseja realmente apagar este registro?',
			showCancelButton: true,
			showCloseButton: true,
			confirmButtonText: 'Apagar',
			cancelButtonText: 'Cancelar',
			confirmButtonColor: '#d33'
			  
		}).then((result) => {
			if(result.value == true){
				this.clienteSvc.apagaCliente(id).then((data) => {
					this.pegaClientes();
					Swal.fire({
						type: 'success',
						title: 'Apagado com sucesso!'
					});
				}).catch((err) => {
					console.log(err);
					Swal.fire({
						type: 'error',
						title: 'Ops! Algo de errado aconteceu!',
						text: 'Não foi possível apagar este registro, tente novamente mais tarde.'
					});
				});
			}
		})
	}

	onChangeStatus(cliente_id, event){
		this.loading = true;
		let status = event.srcElement.checked == true ? 'A' : 'I';
		let toSend = ({
		  'cliente_id': cliente_id,
		  'cliente_status': status,
		});
		
		this.clienteSvc.atualizaStatus(toSend).then((data) => {
		  this.loading = false;
		  Swal.fire({
			type: 'success',
			title: 'Status alterado com sucesso!'
		  });
		}).catch(err => {
		  console.log(err);
		  this.loading = false;
		  Swal.fire({
			type: 'error',
			title: 'Ops! Algo de errado aconteceu!',
			text: 'Tente novamente mais tarde.'
		  });
		});
	}
}
